export enum ColumnDataType {
    String,
    Int,
    Double,
    Date,
    Score,
    Percent,
    List,
    Day,
    Week,
    Duration,
    Location,
    Boolean
}
